import moment from 'moment';

import { store } from '../app/store';
import CallConstants from '../constants/Call';

class CommunicationService {
  static formatCallTime = (totalSeconds: number) => {
    const time = moment.duration({ s: totalSeconds });
    const timeFormatted = moment().startOf('day').add(time).format('mm:ss');

    return timeFormatted;
  }

  static getOutgoingPhoneNumber = () => {

    const userPreferences = store.getState()?.auth?.user?.preferences;
    const phoneNumberId = userPreferences?.outgoingCallIdPreference?.phoneNumberId;
    const callerIdType = userPreferences?.outgoingCallIdPreference?.callerIdType;
    const tenantSettings = store.getState()?.settings?.tenantSettings;
    const user = store.getState()?.auth?.user;
    const userTeam = store.getState()?.auth?.userTeam;
    const assignedTeam = userTeam ?? null;
    let result = null;

    if (callerIdType === CallConstants.OutgoingCallIdEnums.Organisation && phoneNumberId === tenantSettings?.phoneNumber?.id) {
      result = tenantSettings?.phoneNumber?.number;
    } else if (callerIdType === CallConstants.OutgoingCallIdEnums.Team && phoneNumberId === assignedTeam?.number?.id) {
      result = assignedTeam?.number?.number;
    } else if (callerIdType === CallConstants.OutgoingCallIdEnums.Personal && phoneNumberId === user?.phone?.id) {
      result = user?.phone?.number;
    } else if (callerIdType === CallConstants.OutgoingCallIdEnums.Personal && phoneNumberId === user?.mobilePhone?.id) {
      result = user?.mobilePhone?.number;
    } else if (callerIdType === CallConstants.OutgoingCallIdEnums.LocalPresence && phoneNumberId === '') {
      result = CallConstants.OutgoingCallIdEnums.LocalPresence;
    }

    if (!result) {
      result = tenantSettings?.phoneNumber?.number || assignedTeam?.number?.number || user?.phone?.number || user?.mobilePhone?.number;
    }

    return result;
  }
}

export default CommunicationService;
